// extracted by mini-css-extract-plugin
export default {"lawyers":"style_lawyers__Tu6wE","map":"style_map__s+Z2T","searchBarContainer":"style_searchBarContainer__qx5jK","listContainer":"style_listContainer__A+Rsr"};